export default "__VITE_ASSET__C$wJeYv5__"